import React, { useEffect, useRef } from "react";
import { gsap } from "gsap";
import AccordionItem from "../general/AccordionItem/AccordionItem";
import Button from "../general/Button/Button";
import "./ShowcaseModal.css";

const ShowcaseModal = ({ format, onClose, onCopyUrl }) => {
  const overlayRef = useRef(null);
  const modalRef = useRef(null);
  const isClosingRef = useRef(false);

  useEffect(() => {
    if (!format) return;

    // Animação de entrada
    gsap.fromTo(
      overlayRef.current,
      { opacity: 0 },
      { opacity: 1, duration: 0.25, ease: "power2.out" }
    );
    gsap.fromTo(
      modalRef.current,
      { y: 20, scale: 0.96, opacity: 0 },
      { y: 0, scale: 1, opacity: 1, duration: 0.35, ease: "power3.out" }
    );

    // Fechar com ESC
    const handleEsc = (e) => {
      if (e.key === "Escape") handleClose();
    };
    window.addEventListener("keydown", handleEsc);
    return () => window.removeEventListener("keydown", handleEsc);
  }, [format]);

  const handleClose = () => {
    if (isClosingRef.current) return; // Evita cliques múltiplos
    isClosingRef.current = true;

    gsap.to(modalRef.current, {
      y: 20,
      scale: 0.95,
      opacity: 0,
      duration: 0.25,
      ease: "power2.in",
    });

    gsap.to(overlayRef.current, {
      opacity: 0,
      duration: 0.25,
      ease: "power2.in",
      onComplete: () => {
        isClosingRef.current = false;
        onClose && onClose();
      },
    });
  };

  if (!format) return null;

  return (
    <div
      ref={overlayRef}
      className="showcase-modal-overlay"
      onClick={handleClose}
    >
      <div
        ref={modalRef}
        className="showcase-modal"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <header className="showcase-modal-header">
          <div className="showcase-modal-header-info">
            <h2>{format.name}</h2>
            <span className="showcase-badge">{format.category}</span>
          </div>
          <span className="btn-close" onClick={handleClose}>
            ×
          </span>
        </header>

        {/* Main Content */}
        <div className="showcase-modal-main">
          {format.preview && (
            <div className="showcase-modal-preview">
              {format.type === "video" ? (
                <video
                  src={format.preview}
                  autoPlay
                  loop
                  muted
                  controls
                  playsInline
                  preload="metadata"
                />
              ) : (
                <img src={format.preview} alt={format.name} />
              )}
            </div>
          )}

          <div className="showcase-modal-body">
            <AccordionItem title="Technical Specifications" defaultOpen>
              <ul className="showcase-specs">
                {(format.specs || []).map((spec, i) => (
                  <li key={i}>{spec}</li>
                ))}
              </ul>
            </AccordionItem>
          </div>
        </div>

        {/* Footer */}
        <footer className="showcase-modal-footer">
          {format.docUrl && (
            <>
            <Button
              variant="doc"
              className="btn-doc"
              onClick={() => window.open(format.docUrl, "_blank", "noopener")}
            >
              View Documentation (logged-in users)
            </Button>
            <Button className="copy-url-btn" onClick={onCopyUrl}>
              🔗 Copy URL
            </Button>
            </>
          )}

          {format.platformPreviewLink && (
            <>
            <Button
              variant="preview"
              className="btn-preview"
              onClick={() =>
                window.open(format.platformPreviewLink, "_blank", "noopener")
              }
            >
              View Preview
            </Button>
            <Button className="copy-url-btn" onClick={onCopyUrl}>
              🔗 Copy URL
            </Button>
            </>
          )}
        </footer>
      </div>
    </div>
  );
};

export default ShowcaseModal;
